




































import { defineComponent, ref, watch, computed } from '~/utils/nuxt3-migration'
import { addYears, format, parseDate } from '~/utils/date'
import CDatePicker from '~/components/shared/configurable/date/CDatePicker.vue'
import { facetHandlerComponentProps } from '~/constants/classified/search/facet'
import useClassifiedSearchFacet from '~/compositions/classified-search/useClassifiedSearchFacet'

export default defineComponent({
  props: facetHandlerComponentProps,
  components: { CDatePicker },
  setup(props) {
    const { changeParams } = useClassifiedSearchFacet()

    const dateFrom = ref(
      props.selected?.low ? parseDate(props.selected.low, 'd/M/yyyy') : null
    )
    const dateTo = ref(
      props.selected?.high ? parseDate(props.selected.high, 'd/M/yyyy') : null
    )

    watch(
      () => props.selected,
      newValue => {
        dateFrom.value = newValue.low
          ? parseDate(newValue.low, 'd/M/yyyy')
          : null
        dateTo.value = newValue.high
          ? parseDate(newValue.high, 'd/M/yyyy')
          : null
      }
    )

    const datepickerFromMinDate = computed(() => new Date())

    const datepickerFromMaxDate = computed(() => {
      const oneYearLater = addYears(new Date(), 1)

      return dateTo.value ? dateTo.value.toISOString() : oneYearLater
    })

    const datepickerToMinDate = computed(() => {
      return dateFrom.value
        ? dateFrom.value.toISOString()
        : new Date().toISOString()
    })

    const datepickerToMaxDate = computed(() => {
      const oneYearLater = addYears(new Date(), 1)

      return oneYearLater.toISOString()
    })

    function onClear() {
      dateFrom.value = null
      dateTo.value = null

      changeParams([
        {
          name: `${props.urlArgNames[0]}-from`,
          value: null
        },
        {
          name: `${props.urlArgNames[0]}-to`,
          value: null
        }
      ])
    }

    function onDateFromUpdate(date: Date) {
      changeParams([
        {
          name: `${props.urlArgNames[0]}-from`,
          value: date ? format(date, 'd/M/yyyy') : null
        }
      ])
    }

    function onDateToUpdate(date: Date) {
      changeParams([
        {
          name: `${props.urlArgNames[0]}-to`,
          value: date ? format(date, 'd/M/yyyy') : null
        }
      ])
    }

    return {
      dateFrom,
      dateTo,
      datepickerFromMinDate,
      datepickerFromMaxDate,
      datepickerToMinDate,
      datepickerToMaxDate,
      onClear,
      onDateFromUpdate,
      onDateToUpdate
    }
  }
})
